import { Icon, IconName, Popover, Text, usePopoverState } from '@talos/kyoko';

export * from './disclaimers';
export function DisclaimerTooltip({ children }: React.PropsWithChildren) {
  const infoPopover = usePopoverState({
    usePortal: false,
    trigger: 'hover',
    placement: 'bottom',
    isSmall: true,
    delay: undefined,
    preventOverflow: true,
  });

  return (
    <Popover {...infoPopover}>
      <Icon color="colorTextImportant" icon={IconName.InformationCircleSolid} />
      <Text maxWidth={300} whiteSpace="break-spaces">
        {children}
      </Text>
    </Popover>
  );
}
